import React, { useEffect, useState } from 'react';
import { hurricaneApi } from '../api';

function HurricaneAdmin() {
  const [events, setEvents] = useState([]);
  const [form, setForm] = useState({ name: '', season: '', sortOrder: 0, isActive: true });
  const [error, setError] = useState('');
  const [msg, setMsg] = useState('');

  const load = async () => {
    const res = await hurricaneApi.adminEvents();
    setEvents(res.data);
  };

  useEffect(() => {
    load().catch((e) => setError(e.response?.data?.error || 'Load failed'));
  }, []);

  const save = async (e) => {
    e.preventDefault();
    setError('');
    setMsg('');
    try {
      await hurricaneApi.adminCreateEvent(form);
      setForm({ name: '', season: '', sortOrder: 0, isActive: true });
      setMsg('Hurricane added.');
      await load();
    } catch (err) {
      setError(err.response?.data?.error || 'Failed');
    }
  };

  const toggle = async (ev) => {
    await hurricaneApi.adminUpdateEvent(ev.id, { isActive: !ev.is_active });
    await load();
  };

  const remove = async (ev) => {
    if (!window.confirm(`Delete hurricane "${ev.name}"?`)) return;
    try {
      await hurricaneApi.adminDeleteEvent(ev.id);
      await load();
    } catch (err) {
      setError(err.response?.data?.error || 'Delete failed');
    }
  };

  return (
    <div className="app-shell-page">
      <h2 className="h4 mb-3">Hurricane admin</h2>
      <p className="text-muted small">Manage named hurricane events used when starting reports.</p>
      {error && <div className="alert alert-danger">{error}</div>}
      {msg && <div className="alert alert-success">{msg}</div>}

      <div className="card app-card bg-white mb-4">
        <div className="card-body p-0">
      <table className="table table-sm mb-0">
        <thead>
          <tr>
            <th>Name</th>
            <th>Season</th>
            <th>Order</th>
            <th>Active</th>
            <th />
          </tr>
        </thead>
        <tbody>
          {events.map((ev) => (
            <tr key={ev.id}>
              <td>{ev.name}</td>
              <td>{ev.season || '—'}</td>
              <td>{ev.sort_order}</td>
              <td>
                <button type="button" className="btn btn-sm btn-outline-secondary" onClick={() => toggle(ev)}>
                  {ev.is_active ? 'Yes' : 'No'}
                </button>
              </td>
              <td>
                <button type="button" className="btn btn-sm btn-outline-danger" onClick={() => remove(ev)}>
                  Delete
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
        </div>
      </div>

      <form className="card app-card bg-white card-body" style={{ maxWidth: 480 }} onSubmit={save}>
        <h6 className="mb-3">Add hurricane</h6>
        <input
          className="form-control form-control-sm mb-2"
          placeholder="Hurricane name *"
          value={form.name}
          onChange={(e) => setForm({ ...form, name: e.target.value })}
          required
        />
        <input
          className="form-control form-control-sm mb-2"
          placeholder="Season (optional)"
          value={form.season}
          onChange={(e) => setForm({ ...form, season: e.target.value })}
        />
        <input
          type="number"
          className="form-control form-control-sm mb-2"
          placeholder="Sort order"
          value={form.sortOrder}
          onChange={(e) => setForm({ ...form, sortOrder: Number(e.target.value) })}
        />
        <button type="submit" className="btn btn-primary btn-sm">Add hurricane</button>
      </form>
    </div>
  );
}

export default HurricaneAdmin;
